import { useQuery } from '@tanstack/react-query';
import type { SupabaseClient } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase';
import type { LiveEvent, LiveCampaignCover, LivePrizeCards, LivePrizeWinner } from './live-events';

// RPC postérieure aux types générés (stale, cf. CLAUDE.md).
const db = supabase as unknown as SupabaseClient;

export interface LiveEventsResponse {
  server_time: number;
  level: string;
  upcoming: LiveEvent[];
  past: LiveEvent[];
  campaigns: LiveCampaignCover[];
  /** Lots des lives de programme (0329). */
  prizes?: LivePrizeCards;
  /** Podium des lives passés, par challenge_id. */
  winners?: Record<string, LivePrizeWinner[]>;
}

/**
 * Événements Live School (passés + à venir) du niveau `level`, via la RPC
 * `get_live_events` (migration 0361, security definer : les défis `scheduled`
 * sont invisibles au client en direct). Même réponse que l'ancienne edge fn
 * `live-events` (gardée pour les apps déjà installées), ~10× plus rapide.
 * Aucune question ni réponse : seulement le calendrier. Désactivé tant
 * qu'aucun niveau n'est choisi.
 */
export function useLiveEvents(level: string | null) {
  return useQuery({
    queryKey: ['live-events', level ?? ''],
    enabled: !!level,
    staleTime: 30_000,
    queryFn: async () => {
      const { data, error } = await db.rpc('get_live_events', { p_level: level });
      if (error) throw new Error(error.message);
      return data as LiveEventsResponse;
    },
  });
}
